/* global axios */
import ApiClient from './ApiClient';

class ConversationApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getLabels(conversationID) {
    return axios.get(`${this.url}/${conversationID}/labels`);
  }

  updateLabels(conversationID, labels) {
    return axios.post(`${this.url}/${conversationID}/labels`, { labels });
  }

  needTemplate(params) {
    let requestURL = `${this.url}/need_template`;
    return axios.post(requestURL, params);
  }

  setMemo(conversationID, memoMessage) {
    return axios.post(`${this.url}/${conversationID}/set_memo`, {
      memo_message: memoMessage,
    });
  }

  deleteMemo(conversationID) {
    return axios.delete(`${this.url}/${conversationID}/delete_memo`);
  }
}

export default new ConversationApi();
